import axios from "axios";

const user = JSON.parse(localStorage.getItem("user") ?? "false");

// const headers = {
//   "Content-Type": "application/json",
//   Authorization: `${user.accessToken}`,
// };
const getCurriForSetting = async (type: string) => {
  return await axios.get(`curriculum/${type}`);
};

const getCourse = async (id: number) => {
  return await axios.get(`course/${id}`);
};

const saveSetting = async (data: any) => {
  return await axios.post("send-list", data);
};

const countCourse = async (schedule: number) => {
  return axios.get(`send-list/${schedule}`);
};

const deleteById = async (id: number) => {
  return axios.delete(`/send-list/${id}`);
};

export default {
  getCurriForSetting,
  getCourse,
  saveSetting,
  countCourse,
  deleteById,
};
